import type {IModalOverlayVariant} from "@pg-design/modal-module";
import {UserUpdatePhoneNumberModal as UserUpdatePhoneNumberModalBase} from "@pg-mono/user";

import {UserUpdatePhoneNumberModalProvider} from "../../providers/UserUpdatePhoneNumberModalProvider";

interface IProps {
    isOpen: boolean;
    onClose: () => void;
    onSuccess: () => void;
    overlayVariant?: IModalOverlayVariant;
}

export const HomeMatchBasicPreferencesFlowPhoneUpdateModal = (props: IProps) => {
    const {isOpen, onClose, onSuccess, overlayVariant} = props;

    return (
        <UserUpdatePhoneNumberModalProvider onCloseOverride={onClose}>
            <UserUpdatePhoneNumberModalBase isOpen={isOpen} onSuccess={onSuccess} overlayVariant={overlayVariant} />
        </UserUpdatePhoneNumberModalProvider>
    );
};
import type {IModalOverlayVariant} from "@pg-design/modal-module";
import {UserUpdatePhoneNumberModal as UserUpdatePhoneNumberModalBase} from "@pg-mono/user";

import {UserUpdatePhoneNumberModalProvider} from "../../providers/UserUpdatePhoneNumberModalProvider";

interface IProps {
    isOpen: boolean;
    onClose: () => void;
    onSuccess: () => void;
    overlayVariant?: IModalOverlayVariant;
}

export const HomeMatchBasicPreferencesFlowPhoneUpdateModal = (props: IProps) => {
    const {isOpen, onClose, onSuccess, overlayVariant} = props;

    return (
        <UserUpdatePhoneNumberModalProvider onCloseOverride={onClose}>
            <UserUpdatePhoneNumberModalBase isOpen={isOpen} onSuccess={onSuccess} overlayVariant={overlayVariant} />
        </UserUpdatePhoneNumberModalProvider>
    );
};
